import authentication from "@irati/auth"
import {Deal, Wallet} from "@irati/types"

import {isPaymentRequired} from "./redemption/deal"

export default (deal: Deal, wallet: Wallet) => authentication.apps("wallet.users") && isPaymentRequired(deal) && wallet.availableBalance > 0
